// FIXME: バージョンの狭間で対応する hooks が提供されていないので自作でなんとかする

export var useStore = function useStore() {
  var _useNuxtApp = useNuxtApp(),
    $store = _useNuxtApp.$store;
  return $store;
};